import { TFunction } from "react-i18next"
import { DynamicFormRefValues } from "../../../../../../../components/dynamicFormRef/types"
import { EvidenceData } from "../../../../../../../hooks/evidences/typyng"
import { ActionPlan, ConfigReportFolio, QuestionEvidence, QuestionnaireCommentConfig, QuestionnaireSection, QuestionOption, Step, StepQuestion } from "../../../../../../../service/questionarie/response"
import { EvidencesTypeValueEnum } from "../../../../../../../utils/enums/evidences"
import { transformEvidencesNumber } from "../../../../../../../utils/methods/evidences"
import { Item } from "../../../../../../../utils/types/generals"
import { DefaultReportFolio, OptionActionSavePayload, ReincidenceData } from "../../../../../components/optionActions/types"
import { fields } from "../../../../../constants"
import { Answer, Question, QuestionTemmplate } from "../../../fragments/section/contextProvider/provider/types"
import { typeUser } from "../../../methods/actionPlan/contants"
import { TypeTypeUser } from "../../../methods/actionPlan/type"
import { ActionPlanData } from "../../../typing/types"
import { roundTo } from "../../../../../../../utils/methods/removeDecimals"

const formatSection = ({ section, t }: { section: QuestionnaireSection; t: TFunction<"translation", undefined> }) => {
    const questionItems: Item[] = section.steps?.map(question => ({ id: question.questionId.toString(), label: question.question.title, value: question.questionId }))
    const questionList = section.steps.map((step) => (formatStepQuestion({ step, t, questionItems })))
    const totalWithoutFormat = questionList.reduce((count, section) => count + Number(section?.totalQuestionPoints ?? 0), 0)

    return ({
        id: String(section?.id),
        sectionDefault: {
            description: section?.description,
            sectionName: section?.title,
            sectionPoints: String(section?.totalPoints ?? 0)
        },
        totalSection: roundTo(totalWithoutFormat,2),
        questionListDefault: questionList
    })

}
const formatStepQuestion = ({ step, t, questionItems }: { step: Step; t: TFunction<"translation", undefined>; questionItems: Item[] }): Question => {
    const question = step?.question
    const { answers, questionTemplate, totalCorrectPoints } = formatAnswer({ question: step?.question, t, answer: question?.description, questionItems })
    const isMulltiple = question?.typeQuestion.id == 2
    let config: OptionActionSavePayload = {}
    const questionEvidenceConfig = [questiononEvidencesToEvidenceData(question?.questionEvidence)]

    const hasNotApplicable  = answers.some(item => item.notApplicable === true);

    if (isMulltiple) {
        const option = question?.questionOptions.find(option => !!option.actionPlan || option.questionOptionEvidence.length !==0 || !!option.recurrence || !!option.questionOptionsConfigReportFolio )
        //const optionRecurrence = question?.questionOptions.find(option => !!option.recurrence)
        if (option?.actionPlan) { config.actionPlan = configActionPlan({ actionPlan: option?.actionPlan, t }) }
        if (option?.questionOptionEvidence?.length) { config.evidenceData = [questiononEvidencesToEvidenceData(option?.questionOptionEvidence)] }
        if (option?.questionOptionsConfigReportFolio) { config.reportFolio = configReportFolio(option?.questionOptionsConfigReportFolio) }
        if (option?.recurrence) { config.reincidence = formatCommentConfigRecurrece({ option: option ?? null }) }
    }
    return {
        id: String(question?.id),
        question: {
            notApplicable:hasNotApplicable,
            id: String(question?.id),
            questionText: question?.title,
            helpText: question?.textHelp ?? '',
            questionOption: { id: String(question?.typeQuestion?.id), value: String(question?.typeQuestion?.id), label: question?.typeQuestion?.description },
            questionTemplate: questionTemplate,
            config: question?.questionEvidence.length ? JSON.stringify({ evidenceData: questionEvidenceConfig }) : undefined
        },
        configGeneral: isMulltiple ? JSON.stringify(config) : undefined,
        answer: answers,
        totalQuestionPoints: totalCorrectPoints
    }
}

const formatAnswer = ({ question, t, answer, questionItems }: { question: StepQuestion; t: TFunction<"translation", undefined>; answer?: string | null; questionItems: Item[] }) => {
    let questionTemplate: QuestionTemmplate | undefined
    let totalCorrectPoints = 0
    const isAffective = String(question?.typeQuestion.id) == '4'
    const isMultiple = String(question?.typeQuestion.id) == '2'
    const answers: Answer[] = question?.questionOptions?.map(option => {
        if (question?.optionGroupId) {
            questionTemplate = {
                id: String(question?.optionGroupId),
                value: String(question?.optionGroupId),
                label: '',
                options: question?.questionOptions.map(option => ({
                    id: option?.option?.id,
                    optionGroupId: option?.option?.optionGroupId,
                    iconUrl: option?.option?.iconUrl ?? '',
                    description: option?.option?.description ?? ''
                })),
            }
        }

        if (option?.correctOption) { totalCorrectPoints = totalCorrectPoints + Number(option?.score) }
        let config: OptionActionSavePayload = {}
        if (!isMultiple) {
            if (option?.actionPlan) { config.actionPlan = configActionPlan({ actionPlan: option?.actionPlan, t }) }
            if (option?.questionOptionEvidence?.length) { config.evidenceData = [questiononEvidencesToEvidenceData(option?.questionOptionEvidence)] }
            if (option?.questionOptionsConfigReportFolio) { config.reportFolio = configReportFolio(option?.questionOptionsConfigReportFolio) }
            if (option?.recurrence) { config.reincidence = formatCommentConfigRecurrece({ option: option }) }
        }
        return ({
            id: String(option?.id),
            action: option?.stepId ? questionItems[option.stepId] : undefined,
            value: option?.score,
            activeReeportFolio: (isMultiple && (option?.actionPlan || option?.questionOptionsConfigReportFolio || !!option.recurrence || option?.questionOptionEvidence.length !== 0)) ? true : undefined,
            switchOption: Boolean(option?.correctOption),
            notApplicable: Boolean(option?.notApplicable),
            config: isMultiple ? undefined : JSON.stringify(config),
            answer: isAffective ? { text: option?.option?.description, file: option?.option?.iconUrl } : (option?.option?.description || answer || '')
        })
    })
    return { answers, questionTemplate, totalCorrectPoints }
}

export const questiononEvidencesToEvidenceData = (evidence: QuestionEvidence[] = [], defaultType?: (TypeTypeUser | null)): EvidenceData => {
    let newEvidences: EvidenceData = {}
    const typeNull = defaultType ?? null
    for (const item of evidence) {
        const typeEvidence = item.type ?? item.typeUser ?? typeNull
        if (item?.paramsConfiguration) {
            switch (item.evidenceTypeId) {
                case EvidencesTypeValueEnum.IMAGE:
                case EvidencesTypeValueEnum.CAMERA:
                case EvidencesTypeValueEnum.DOCUMENT:
                case EvidencesTypeValueEnum.VIDEO_GALLERY:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            type: typeEvidence,
                            ...!!item?.paramsConfiguration && {
                                "maxSize": {
                                    "label": `${item?.paramsConfiguration?.sizes} Mb`,
                                    "value": item?.paramsConfiguration?.sizes
                                },
                                "maxAmount": item?.paramsConfiguration?.amounts || '1',
                                "minAmount": item?.paramsConfiguration?.min || '1'
                            }
                        }
                    }

                    for (const itemTypes of (item?.paramsConfiguration?.types ?? [])) {
                        newEvidences[transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]] = {
                            ...newEvidences[transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]],
                            [itemTypes]: true
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.VIDEO:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxSize": {
                                "label": `${item?.paramsConfiguration?.sizes} Mb`,
                                "value": item?.paramsConfiguration?.sizes
                            },
                            type: typeEvidence,
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            "minAmount": item?.paramsConfiguration?.min || '1'
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.SIGN:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            type: typeEvidence,
                            "minAmount": item?.paramsConfiguration?.min || '1'
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.COMMENT:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            "maxAmount": item?.paramsConfiguration?.amounts || '1',
                            "minAmount": item?.paramsConfiguration?.min || '1',
                            type: typeEvidence,
                            maxCharacters: item?.paramsConfiguration?.sizes
                        }
                    }
                    break;
                case EvidencesTypeValueEnum.OBSERVATION_COMMENT:
                    newEvidences = {
                        ...newEvidences,
                        [transformEvidencesNumber[item.evidenceTypeId as EvidencesTypeValueEnum]]: {
                            "active": true,
                            "required": item.required,
                            type: typeEvidence,
                            maxCharacters: item?.paramsConfiguration?.sizes
                        }
                    }
                    break;
            }
        }
    }

    return newEvidences
}

const separateEvidenceType = (evidences: QuestionEvidence[] | undefined = []) => {
    let separated: Record<string, QuestionEvidence[]> = {
        solverList: [],
        creatorList: [],
        approver: [],
        reject: [],
        create: [],
    }
    for (const evidence of evidences) {
        if (evidence.type == typeUser.SOLVER) { separated.solverList.push(evidence) }
        if (evidence.type == typeUser.CREATOR) { separated.creatorList.push(evidence) }
        if (evidence.type == typeUser.APPROVER) { separated.approver.push(evidence) }
        if (evidence.type == typeUser.CREATE) { separated.create.push(evidence) }
        if (evidence.type == typeUser.REJECT || evidence.type == null) { separated.reject.push({ ...evidence, type: typeUser.REJECT }) }
    }
    return separated
}
const configActionPlan = ({ actionPlan, t }: { actionPlan: ActionPlan | null; t: TFunction<"translation", undefined>; }): ActionPlanData => {
    const { creatorList, solverList } = separateEvidenceType(actionPlan?.actionPlanEvidences)
    const { approver, reject } = separateEvidenceType(actionPlan?.configReportFolio?.configActionPlanReportFolioEvidenceTypes)
    let body = {
        evidence: [questiononEvidencesToEvidenceData(creatorList), questiononEvidencesToEvidenceData(solverList),],
        data: {
            maxReject: actionPlan?.maxRejections ?? '1',
            sendEmail: Boolean(actionPlan?.sendEmail)
        },
        description: {
            "title": actionPlan?.templateName ?? '',
            "description": actionPlan?.description ?? ''
        },
        options: {
            "evidences": {
                "sameConfig": Boolean(actionPlan?.userConfigEvidence)
            }
        },
        ...!!actionPlan?.configReportFolio && {
            evidenceFolio: [questiononEvidencesToEvidenceData(approver), questiononEvidencesToEvidenceData(reject),],
            dataFolios: {
                enable: Boolean(!!actionPlan?.configReportFolio.ratingQuestion),
                required: Boolean(actionPlan?.configReportFolio.isRatingQuestionRequired),
                description: actionPlan?.configReportFolio.ratingQuestion || t('reportFolio.detail.approve.title'),
                reportFolioIsRequired: Boolean(actionPlan?.configReportFolio?.isRequired),
                // reportFolioIsRequired: Boolean(!!actionPlan?.configReportFolio.ratingQuestion),
                maxFoliosAmount: actionPlan?.configReportFolio.max || 1,
                maxRejectsAmount: actionPlan?.configReportFolio.maxRejects || 1
            },
            limitFolio: {
                "maxFolios": !!actionPlan?.configReportFolio.max,
                "maxFoliosAmount": actionPlan?.configReportFolio.max
            },
            rejectsFolio: {
                "maxRejects": !!actionPlan?.configReportFolio.maxRejects,
                "maxRejectsAmount": actionPlan?.configReportFolio.maxRejects,
                "enableSurvey": !!actionPlan?.configReportFolio.ratingQuestion,
                "enableSurveyRequired": actionPlan?.configReportFolio.isRatingQuestionRequired,
                "satisfactionQuestion": actionPlan?.configReportFolio.ratingQuestion
            },
            activeFolios: !!actionPlan?.configReportFolio,
        },
    }
    for (const field of fields) {
        const actionPlanLocale = actionPlan?.actionPlanItems?.find((itemPlan: any) => itemPlan.question === t?.(`general.questions.${field}`))
        body = {
            ...body,
            data: {
                ...body?.data ?? {},
                [`${field}-check`]: !!actionPlanLocale,
                [`${field}-switch`]: !!actionPlanLocale?.required,
            }
        }
    }
    return body
}

const configReportFolio = (reportFolio: ConfigReportFolio | null): DefaultReportFolio => {

    const { approver, reject } = separateEvidenceType(reportFolio?.configActionPlanReportFolioEvidenceTypes)
    return {
        evidence: {
            evidencesData: [questiononEvidencesToEvidenceData(approver), questiononEvidencesToEvidenceData(reject),],
            anchorEl: null,
        },
        default: {
            enable: Boolean(!!reportFolio?.ratingQuestion),
            required: Boolean(reportFolio?.isRatingQuestionRequired),
            description: reportFolio?.ratingQuestion ?? '',
            reportFolioIsRequired: Boolean(reportFolio?.isRequired),
            // reportFolioIsRequired: Boolean(!!actionPlan?.configReportFolio.ratingQuestion),
            maxFoliosAmount: reportFolio?.max || 1,
            maxRejectsAmount: reportFolio?.maxRejects || 1
        }
    } as any
}

const formatCommentConfigResponse = ({ config }: { config: QuestionnaireCommentConfig }): {
    evidence: EvidenceData[];
    default?: DynamicFormRefValues | undefined;
} => {
    return {
        evidence: [questiononEvidencesToEvidenceData(config?.questionnaireCommentEvidenceConfig)],
        default: {
            comment: Boolean(config?.required)
        }
    }
}
const formatCommentConfigRecurrece = ({ option }: { option: QuestionOption | null }): ReincidenceData => {
    const recurrence = option?.answersAmountRecurrence ?? 0
    return {
        reincidence: String(recurrence > 1 ? recurrence : 2),
        block: String(option?.amountRecurrenceUser ?? 1)
    }
}
export { configActionPlan, formatCommentConfigResponse, formatSection, formatStepQuestion, separateEvidenceType }
